module.exports = __webpack_public_path__ + "img/9788937886522.adc18fc7.jpg";